import React from "react";
import { FrVrfDropdownField } from "@vrf/fr-vrf-web-components-react";
import { ReviewDiffTarget } from "../../pages/interface-definitions";
import { REVIEW_DIFF_TARGET } from "../../pages/interface-definitions/InterfaceListPageConstant";

type Props = {
  visible: boolean;
  selectedValue: ReviewDiffTarget;
  onValueChanged: (event: CustomEvent) => void;
  children?: React.ReactNode;
};

const reviewDiffTargetOptions = [
  { label: "None", value: REVIEW_DIFF_TARGET.NONE },
  { label: "Previous review", value: REVIEW_DIFF_TARGET.PREV_REVIEW },
  { label: "Current STG snapshot", value: REVIEW_DIFF_TARGET.LATEST_STG },
  { label: "Current PRD snapshot", value: REVIEW_DIFF_TARGET.LATEST_PRD },
  { label: "STG snapshot at PJ start", value: REVIEW_DIFF_TARGET.PJ_START_STG },
  { label: "PRD snapshot at PJ start", value: REVIEW_DIFF_TARGET.PJ_START_PRD },
];

export const DiffDropdownField: React.FC<Props> = ({
  visible,
  selectedValue,
  onValueChanged,
  children,
}) => {
  if (!visible) return null;

  return (
    <div
      style={{
        paddingBottom: "5px",
        display: "flex",
        justifyContent: "flex-start",
        width: "fit-content",
      }}
    >
      <FrVrfDropdownField
        autocomplete={false}
        labelContent="Compare to"
        selectedValue={selectedValue}
        includeDefaultValue={false}
        items={reviewDiffTargetOptions}
        onValueChanged={onValueChanged}
        style={{
          "--vrf-dropdown-field-label-width": "64px",
          "--vrf-dropdown-field-select-width": "150px",
        }}
      />
      {children}
    </div>
  );
};
